import React from "react";
import { useTranslation } from "react-i18next";
import { Input, Select, Typography, Row, Col } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";

const { Title, Text } = Typography;
const { Option } = Select;

// Helper para comparar URLs ignorando encoded chars (%20 vs espacio)
const isSameImage = (url1, url2) => {
  if (!url1 || !url2) return false;
  // Decodificamos ambas para asegurar que "Foto%20Sala.png" sea igual a "Foto Sala.png"
  return decodeURIComponent(url1) === decodeURIComponent(url2);
};

export function Step1Identity({ data, categories, onChange }) {
  const { t } = useTranslation("rooms");

  return (
    <div className="wizard-step">
      <div className="form-section">
        <Title level={5}>{t("asistenteTerapia.paso1.nombre")}</Title>
        <Input
          placeholder={t("asistenteTerapia.paso1.nombrePlaceholder")}
          value={data.title}
          onChange={(e) => onChange("title", e.target.value)}
          size="large"
        />
      </div>

      <div className="form-section">
        <Title level={5}>{t("asistenteTerapia.paso1.categorias")}</Title>
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder={t("asistenteTerapia.paso1.categoriasPlaceholder")}
          value={data.categories} // Aquí ahora llegarán IDs strings ["id1", "id2"]
          onChange={(vals) => onChange("categories", vals)}
          size="large"
          optionFilterProp="children"
        >
          {categories.map((cat) => (
            <Option key={cat._id} value={cat._id}>
              {cat.title}
            </Option>
          ))}
        </Select>
      </div>

      <div className="form-section">
        <Title level={5}>{t("asistenteTerapia.paso1.portada")}</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 12 }}>
          {t("asistenteTerapia.paso1.portadaAyuda")}
        </Text>

        <div className="image-grid-selector">
          <Row gutter={[16, 16]}>
            {categories.map((cat) => {
              // Usamos la comparación robusta
              const isSelected = isSameImage(data.image, cat.thumbnail);

              return (
                <Col span={6} key={cat._id}>
                  <div
                    className={`img-card ${isSelected ? "selected" : ""}`}
                    onClick={() => onChange("image", cat.thumbnail)}
                  >
                    <img src={cat.thumbnail} alt={cat.title} />
                    {isSelected && (
                      <div className="check-overlay">
                        <CheckCircleFilled />
                      </div>
                    )}
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
    </div>
  );
}
